/* eslint-disable no-barrel-files/no-barrel-files */
// TODO: De-barrel-ize
import { useReprocessDocuments } from 'features/rolodex/hooks/useReprocessDocuments'
import { useRolodexFileLS } from 'features/rolodex/hooks/useRolodexFileList'
import {
  useGetRolodexFileLSFetcher,
  useRolodexFileLSBulk,
} from 'features/rolodex/hooks/useRolodexFileListBulk'
import { useRolodexFileMetadata } from 'features/rolodex/hooks/useRolodexFileMetadata'
import {
  useGetRolodexFilesCopyFetcher,
  useRolodexFilesCopy,
} from 'features/rolodex/hooks/useRolodexFilesCopy'
import { useRolodexHistogram } from 'features/rolodex/hooks/useRolodexHistogram'

import { RolodexEntriesWithSyncedRefreshesProvider } from './extensionFunctions/entriesWithSyncedRefreshes/RolodexEntriesWithSyncedRefreshesProvider'
import {
  useRolodexEntriesWithSyncedRefreshes,
  UseRolodexEntriesWithSyncedRefreshesOptions,
  UseRolodexEntriesWithSyncedRefreshesQuery,
  UseRolodexEntriesWithSyncedRefreshesResult,
} from './extensionFunctions/entriesWithSyncedRefreshes/useRolodexEntriesWithSyncedRefreshes'
import { binaryFetcher, getFetcher, postFetcher } from './fetchers'
import { useGetUserMetadata } from './hooks/useGetUserMetadata'
import {
  CantileverAiQueryResponse,
  EmbeddingMetadata,
  EmbeddingResult,
  EmbeddingRow,
  EmbeddingType,
  Entry,
  ParsedCantileverAiQueryResult,
  useRolodexAi,
} from './hooks/useRolodexAi'
import { RolodexCacheInstance, useRolodexCache } from './hooks/useRolodexCache'
import { useRolodexCachedEntries } from './hooks/useRolodexCachedEntries'
import {
  useGetRolodexAuditLog,
  useGetRolodexEntriesByLoadOptions,
  useRolodexLoadCount,
} from './hooks/useRolodexData'
import {
  DEFAULT_ROLODEX_ENTRY_LIMIT,
  RolodexEntryQueryBody,
  useRolodexEntries,
} from './hooks/useRolodexEntries'
import { useRolodexGraphQL } from './hooks/useRolodexGraphQL'
import { useRolodexMetadata } from './hooks/useRolodexMetadata'
import {
  useFileSignedUrlFetcher,
  useRolodexSignedURLs,
} from './hooks/useRolodexSignedURLs'
import { useUserListing } from './hooks/useUserListing'
import {
  EntryLookupFunction,
  RolodexEntryDispenserType,
} from './rolodexEntryDispenser'
import {
  DeleteCacheValue,
  RolodexContext,
  RolodexProvider,
} from './RolodexProvider'
import {
  generateEntrySlug,
  getGeckoUserOptions,
  isValidEntrySlug,
} from './utils'

export {
  binaryFetcher,
  type CantileverAiQueryResponse,
  DEFAULT_ROLODEX_ENTRY_LIMIT,
  DeleteCacheValue,
  type EmbeddingMetadata,
  type EmbeddingResult,
  type EmbeddingRow,
  type EmbeddingType,
  type Entry,
  type EntryLookupFunction,
  generateEntrySlug,
  getFetcher,
  getGeckoUserOptions,
  isValidEntrySlug,
  type ParsedCantileverAiQueryResult,
  postFetcher,
  type RolodexCacheInstance,
  RolodexContext,
  RolodexEntriesWithSyncedRefreshesProvider,
  type RolodexEntryDispenserType,
  type RolodexEntryQueryBody,
  RolodexProvider,
  useFileSignedUrlFetcher,
  useGetRolodexAuditLog,
  useGetRolodexEntriesByLoadOptions,
  useGetRolodexFileLSFetcher,
  useGetRolodexFilesCopyFetcher,
  useGetUserMetadata,
  useReprocessDocuments,
  useRolodexAi,
  useRolodexCache,
  useRolodexCachedEntries,
  useRolodexEntries,
  useRolodexEntriesWithSyncedRefreshes,
  type UseRolodexEntriesWithSyncedRefreshesOptions,
  type UseRolodexEntriesWithSyncedRefreshesQuery,
  type UseRolodexEntriesWithSyncedRefreshesResult,
  useRolodexFileLS,
  useRolodexFileLSBulk,
  useRolodexFileMetadata,
  useRolodexFilesCopy,
  useRolodexGraphQL,
  useRolodexHistogram,
  useRolodexLoadCount,
  useRolodexMetadata,
  useRolodexSignedURLs,
  useUserListing,
}
